import { render, staticRenderFns } from "./ni-icon-switch.vue?vue&type=template&id=38c9c556"
import script from "./ni-icon-switch.vue?vue&type=script&lang=js"
export * from "./ni-icon-switch.vue?vue&type=script&lang=js"
import style0 from "./ni-icon-switch.vue?vue&type=style&index=0&id=38c9c556&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports